<nz-ribbon nzPlacement="start" nzText="{{ 'medicalConsultations.ribbonTitle' | translate }}">
  <!-- <i nz-icon [nzType]="'check-circle'" [nzTheme]="'fill'"></i> -->
  <nz-card class="appointment-card">
    <div class="card-content">
      <div class="date-time">
        <div class="date">
          <i nz-icon nzType="calendar"></i>
          <span>{{ appointments?.[0]?.appointmentStartDate ? convertDate(appointments?.[0]?.appointmentStartDate, true) : appointments?.[0]?.consultDate }}</span>
        </div>
        <div class="time">
          <i nz-icon nzType="clock-circle"></i>
          <span>{{ appointments?.[0]?.appointmentStartDate ? convertDate(appointments?.[0]?.appointmentStartDate, false) : appointments[0].time }}</span>
        </div>
      </div>
      <div class="appointment-details">
        <p>
          <strong>{{ 'medicalConsultations.type' | translate }}:</strong>
          {{ getTipologia(appointments?.[0]?.consultType) }}
        </p>
        <p>
          <strong>{{ 'medicalConsultations.prestation' | translate }}:</strong>
          {{ getPrestazione(appointments?.[0]?.consultType) }}
        </p>
      </div>
      @if (appointments?.[0]?.status && isStatusVisible(appointments?.[0]?.status)) {
        <div class="status-manage">
          <div class="status">
            <nz-badge
              [style]="getBadgeBackground(appointments?.[0]?.status ?? '')"
              [nzStatus]="getBadgeStatus(appointments?.[0]?.status ?? '')"
              [nzText]="getTranslationKey(appointments?.[0]?.status) | translate"
            ></nz-badge>
          </div>
          @if (
            appointments?.[0]?.consultType !== 'GenericPhone' &&
            appointments?.[0]?.consultType !== 'GenericVideo' &&
            appointments?.[0]?.consultType !== 'GenericTelevisitVideo' &&
            appointments?.[0]?.consultType !== 'CareManager' &&
            (appointments?.[0]?.status.toLowerCase() === 'readytoassist' ||
              appointments?.[0]?.status.toLowerCase() === 'confirmed' ||
              appointments?.[0]?.status.toLowerCase() === 'awaiting')
          ) {
            <ds-button
              [text]="appointments?.[0]?.link ? ('medicalConsultations.enter' | translate) : ('medicalConsultations.handleText' | translate)"
              [width]="'extra-small'"
              [styleType]="'undressed-accent'"
              [iconRight]="'/public/assets/images/icon-right-red.svg'"
              (click)="openModal(appointments?.[0]?.link)"
            ></ds-button>
          }
        </div>
      }
    </div>
    <div class="card-footer">
      <div>
        <i nz-icon nzType="info-circle"></i>
        @if (medicalData && medicalData.lastMeasurement?.disclaimer) {
          <span>{{ 'medicalConsultations.sharedFolder' | translate }}</span>
        } @else {
          <span>{{ 'medicalConsultations.notSharedFolder' | translate }}</span>
        }
      </div>
      <a (click)="shareMedicalData()" nz-button nzType="link" class="modify-link">{{ 'medicalConsultations.modify' | translate }}</a>
    </div>
  </nz-card>
</nz-ribbon>
@if (appointments) {
  <nz-modal [(nzVisible)]="isModalVisible" [nzTitle]="'medicalConsultations.type' | translate" (nzOnCancel)="closeModal()" nzCentered>
    <ng-container *nzModalContent>
      <p class="modal-subtitle">
        {{ 'medicalConsultations.modalSubTitle' | translate }}
      </p>
      <div nz-row [nzGutter]="16" class="container-values">
        <div class="info" nz-col nzSpan="12">
          <p class="title">{{ 'medicalConsultations.type' | translate }}</p>
          <p class="value">{{ getTipologia(appointments?.[0]?.consultType) }}</p>
        </div>
        <div class="info" nz-col nzSpan="12">
          <p class="title">{{ 'medicalConsultations.prestation' | translate }}</p>
          <p class="value">{{ getPrestazione(appointments?.[0]?.consultType) }}</p>
        </div>
        <div class="info" nz-col nzSpan="12">
          <p class="title">{{ 'medicalConsultations.date' | translate }}</p>
          <p class="value">{{ appointments?.[0]?.appointmentStartDate ? convertDate(appointments?.[0]?.appointmentStartDate, true) : appointments?.[0]?.consultDate }}</p>
        </div>
        <div class="info" nz-col nzSpan="12">
          <p class="title">{{ 'medicalConsultations.time' | translate }}</p>
          <p class="value">{{ appointments?.[0]?.appointmentStartDate ? convertDate(appointments?.[0]?.appointmentStartDate, false) : appointments[0].time }}</p>
        </div>
        <div class="actions">
          <a class="delete" (click)="deleteAppointment(appointments[0])">{{ 'medicalConsultations.delete' | translate }}</a>
          <a class="modify" (click)="toggleEditMode(appointments[0])">{{ 'medicalConsultations.modify' | translate }}</a>
        </div>
      </div>
    </ng-container>
    <div *nzModalFooter>
      <div class="buttons">
        <ds-button (click)="closeModal()" [text]="'ESCI'" [width]="'small'" [styleType]="'default-main'"></ds-button>
      </div>
    </div>
  </nz-modal>
}
